import { Form, useFormContext } from "@/components/form";
import { Stack } from "@mui/material";
import type { TextFieldProps, StackProps } from "@mui/material";
import type { ReactNode } from "react";

interface FormFieldWithErrorProps {
  name: string;
  width?: { xs?: string; sm?: string } | string;
  sx?: StackProps["sx"];
  label: string;
  size?: "small" | "medium";
  placeholder?: string;
  inputMode?: TextFieldProps["inputMode"];
  disabled?: boolean;
  customError?: string | null;
  heightError?: string;
  fieldKind?: "text" | "number" | "moneda";
  slotProps?: any;
  children?: (props: {
    name?: string;
    label?: string;
    size?: "small" | "medium";
    placeholder?: string;
    inputMode?: TextFieldProps["inputMode"];
    disabled?: boolean;
    error?: boolean;
    helperText?: string;
    value?: any;
  }) => ReactNode;
}

export function FormFieldWithError({
  name,
  width = "100%",
  sx,
  label,
  size = "small",
  placeholder,
  inputMode,
  disabled = false,
  customError = undefined,
  heightError = "70px",
  fieldKind = "text",
  slotProps,
  children
}: FormFieldWithErrorProps) {
  const form = useFormContext();

  return (
    <Stack width={width} sx={sx}>
      <form.Field name={name}>
        {(field) => {
          const error = customError !== undefined ? customError : field.state.meta?.errors?.[0];

          const commonProps = {
            name,
            label,
            size,
            disabled,
            error: Boolean(error),
            helperText: error ?? " "
          } as const;

          return (
            <Stack height={error ? heightError : 'auto'}>
              {children ? (
                children({
                  ...commonProps,
                  placeholder,
                  inputMode
                })
              ) : (
                fieldKind === "number" ? (
                  <Form.NumberField {...commonProps} slotProps={slotProps} />
                ) : fieldKind === "moneda" ? (
                  <Form.MonedaField {...commonProps} slotProps={slotProps} />
                ) : (
                  <Form.TextField {...commonProps} placeholder={placeholder} inputMode={inputMode} slotProps={slotProps} />
                )
              )}
            </Stack>
          );
        }}
      </form.Field>
    </Stack>
  );
}
